export enum Document {
    
    Dashboard = 3001 ,
    Masters = 3002 ,
    Cheque = 3003,
    Centre = 3004,
    Ledger = 3005,
    SubLedger = 3006,
    CheckList = 3007,
  
}